import React, { Component } from 'react';
import isContractInitialized from '../../utils/ContractInitializationState';
import LoadingAnimation from '../Components/LoadingAnimation';
import { TX_BUY_COINS, TX_ERROR_BUY_COINS } from '../../utils/TransactionTypes';
import {
  addTransactionInProgress,
  transactionErrorHandler,
  transactionReceiptHandler
} from '../../utils/TransactionStateHelper';
import Storage from '../../storage/Storage';

class BuyCoins extends Component {
  constructor (props) {
    super(props);

    this.state = {
      currentAccount: null,
      ether: '',
      coinsToMint: 0,
      contractLoaded: false,
      canBuyCoins: false
    };

    this.storageUnsubscribe = null;
  }

  componentDidMount () {
    this.isContractLoaded();
    this.storageUnsubscribe = Storage.subscribe(() => this.isContractLoaded());
  }

  isContractLoaded () {
    isContractInitialized() && !this.state.contractLoaded && this.init();
  }

  componentWillUnmount () {
    this.storageUnsubscribeHandler();
  }

  storageUnsubscribeHandler () {
    this.storageUnsubscribe && this.storageUnsubscribe();
  }

  init () {
    this.storageUnsubscribeHandler();

    this.setState({
      contractLoaded: true,
    });

    this.checkCanBuyCoins();
    this.initCheckingOfCanBuyCoins();
  }

  checkCanBuyCoins () {
    this.setState({canBuyCoins: Storage.getState().account.canBuyCoins});
  }

  initCheckingOfCanBuyCoins () {
    this.storageUnsubscribe = Storage.subscribe(() => this.checkCanBuyCoins());
  }

  handleEtherChange = (event) => {
    this.setState({
      ether: +event.target.value || '',
      coinsToMint: (+event.target.value || 0) * 10
    });
  };

  handleBuying = (event) => {
    // We don't want normal page submit
    event.preventDefault();

    if (this.state.ether <= 0) {
      window.notifications.showError('Ether must be over 0.');

      return;
    }

    window.contract
      .methods
      .buyTokens()
      .send({
        from: Storage.getState().account.currentAccount,
        value: window.web3Service.utils.toWei(this.state.ether.toString()),
        gasPrice: 0
      })
      .on('transactionHash', (hash) => addTransactionInProgress(hash, TX_BUY_COINS, TX_ERROR_BUY_COINS))
      .on('receipt', (receipt) => transactionReceiptHandler(receipt, () => {
        this.setState({
          ether: ''
        });

        window.notifications.showSuccess('Coins were successfully bought.');
      }))
      .on('error', (err, receipt) => transactionErrorHandler(err, receipt));
  };

  renderForm () {
    if (!this.state.contractLoaded) {
      return (<LoadingAnimation/>);
    }

    if (!this.state.canBuyCoins) {
      return (<div>You are not allowed to buy coins with Ether. Owner has to approve your address for buying of
        coins.</div>);
    }

    return (
      <form onSubmit={this.handleBuying}>
        <div className="c-form-row">
          <label>Ether</label>
          <input type="number" placeholder="Ether" name="ether" value={this.state.ether}
                 onChange={this.handleEtherChange}/>
          <div className="c-buy-coins__exchange-rate">
            {this.state.coinsToMint} ASC
          </div>
        </div>
        <div className="c-form-row">
          <button type="submit">Buy AsyncCoin</button>
        </div>
      </form>
    );
  }

  render () {
    return (
      <div className="c-component c-buy-coins">
        <h2>Buy coins</h2>
        {this.renderForm()}
      </div>
    );
  }
}

export default BuyCoins;



// WEBPACK FOOTER //
// ./src/components/CoinsPage/BuyCoins.js